import React, { useState, useEffect } from 'react';
import HHDetailTooltip from '../../../../Generic/HHDetailTooltip';
import LcAccordionAlt from '../../../../Generic/LcAccordionAlt';
import LcDropDown from '../../../../Generic/LcDropDown';
import LcIconLink from '../../../../Generic/LcIconLink';
import { PrefState } from '../../../../../store/reducers/prefReducer';
import { RootState } from '../../../../../store/index';
import { useDispatch, useSelector } from 'react-redux';

interface Props {
    rows: any[]
    groupType: any
    group: string
    grouperList: any[]
    dynamicTableService: any
    countLength: Function
    expandAll: boolean
    closeAll: boolean
    selectedRadioRows: any[]
    handleMouseMove: Function
    tooltipObject: any
    status: any
    densitySelected: string
    columns: any[]
    fontSize: any
    handleLinkClick: Function
    functionsRow: any[] | undefined
    rowClick: any
    handleRowClick: Function
    functionRadio: any
    getStatusRow: Function
    handleVisible: Function
    expandCloseAll: { expand: boolean, close: boolean }
    clearExpandCloseAll: Function
}

const BodyGroupSingle: React.FC<Props> = (props) => {
    const dispatch = useDispatch();
    const pref = useSelector<RootState, PrefState>(state => state.pref);
    const [type, setType] = useState<string>(`(${props.groupType})${props.group}`);

    const [key, setKey] = useState<string>(`${props.group}-${Date.now()}`);

    useEffect(() => {
        // Atualiza a chave sempre que ocorrer uma mudança relevante, para forçar a recriação do componente e evitar bugs de renderização incorreta devido a mudanças de estado.
        setKey(`${props.group}-${Date.now()}`);
    // }, [props.rows, props.groupType, props.group, props.expandAll, props.closeAll, pref.data?.groupVisible]);
    }, [props.rows, props.groupType]);

    const handleGroupVisible = (visibleValue: boolean) => {
        props.handleVisible(type, visibleValue);
        props.clearExpandCloseAll();
    }

    useEffect(() => {
        if (props.expandAll == true) props.handleVisible(type, true);
        else if (props.closeAll == true) props.handleVisible(type, false);
    }, [props.expandAll, props.closeAll])

    const handleVisible = () => {
        const visible = pref.data?.groupVisible;
        let visibleValue = (visible && visible[type] != undefined) ? visible[type] : true;

        return visibleValue;
    }

    return (
        <div key={key} style={{ marginTop: "20px", marginBottom: "20px" }}>
            <LcAccordionAlt
                title={props.group}
                titleSecondary={"(" + props.countLength(props.rows) + ")"}
                visible={handleVisible()}
                getValue={(visibleValue) => handleGroupVisible(visibleValue)}
                expandAll={props.expandAll}
                closeAll={props.closeAll}
                key={props.group}
            >
                {
                    handleVisible() && props.rows.map((row: any, iRow: number) => {

                        if (row instanceof Array) {
                            const grouperListFiltered = props.grouperList.find(x => x.key === props.groupType);
                            const groupListPosition = props.grouperList.indexOf(grouperListFiltered);
                            const groupType_ = props.grouperList[groupListPosition + 1];
                            const groupType__ = groupType_.key;
                            const group_ = props.dynamicTableService.getGroup(row, groupType__);

                            return (
                                <BodyGroupSingle
                                    rows={row}
                                    groupType={groupType__}
                                    group={group_}
                                    grouperList={props.grouperList}
                                    dynamicTableService={props.dynamicTableService}
                                    countLength={props.countLength}
                                    expandAll={props.expandAll}
                                    closeAll={props.closeAll}
                                    selectedRadioRows={props.selectedRadioRows}
                                    handleMouseMove={props.handleMouseMove}
                                    tooltipObject={props.tooltipObject}
                                    status={props.status}
                                    densitySelected={props.densitySelected}
                                    columns={props.columns}
                                    fontSize={props.fontSize}
                                    handleLinkClick={props.handleLinkClick}
                                    functionsRow={props.functionsRow}
                                    rowClick={props.rowClick}
                                    handleRowClick={props.handleRowClick}
                                    functionRadio={props.functionRadio}
                                    getStatusRow={props.getStatusRow}
                                    key={group_}
                                    handleVisible={props.handleVisible}
                                    expandCloseAll={props.expandCloseAll}
                                    clearExpandCloseAll={props.clearExpandCloseAll}
                                />
                            )
                        }
                        else {

                            return (
                                <div
                                    id={row.id}
                                    className={`${props.selectedRadioRows.includes(row) ? `selectedRow` : ``} rowGroup ${props.densitySelected}`}
                                    // className={props.selectedRadioRows.includes(row) ? `selectedRow rowGroup  ${props.densitySelected}` : `rowGroup  ${props.densitySelected}`}
                                    style={{ borderLeft: props.status && "5px solid " + props.getStatusRow(props.status(row)) }}
                                    key={row.id}
                                    data-tip={row.id}
                                    data-for={"rowDetails " + row.id}
                                    onMouseOver={(e) => props.handleMouseMove(e, row.id)}
                                >
                                    <HHDetailTooltip
                                        tooltipId={"rowDetails " + row.id}
                                        fields={props.tooltipObject.fields}
                                        searchExpandedFields={props.tooltipObject.searchExpandedFields}
                                        rowId={props.tooltipObject.rowId}
                                        mousePosition={props.tooltipObject.mousePosition}
                                        attendant={true}
                                        hide={!props.tooltipObject.hide}
                                        {...props.tooltipObject.tootipPropetiesOptions}
                                    />

                                    <div
                                        className={`status ${props.densitySelected}`}
                                    // style={{ backgroundColor: props.status && props.getStatusRow(props.status(row)) }} 
                                    />
                                    {
                                        props.functionRadio(row)
                                    }

                                    <div className={`cellsGroup`}
                                        style={{
                                            order: "0",
                                            alignSelf: "stretch",
                                            flexGrow: "0",
                                            margin: "4px 0px",
                                            display: 'flex'
                                        }}>
                                        {
                                            props.columns.filter(x => !x.hide).map((col: any, iCol: number) => {
                                                return (
                                                    <a
                                                        className={`cellGroup ${props.fontSize || ''} ${col.align || ''}`}
                                                        href={`/Attendance/${row.id}`}
                                                        style={{ textDecoration: 'none', color: 'black' }}
                                                        onClick={(e) => props.handleLinkClick(e)}
                                                    >
                                                        <div
                                                            className={`cellGroup ${props.densitySelected} ${col.class || ''}`}
                                                            key={iCol}
                                                            style={{
                                                                width: col.width,
                                                                height: col.height ? col.height : '',
                                                                overflow: col.overflow,
                                                                cursor: (props.rowClick && props.rowClick.rowPointer === true) ? "pointer" : "auto",
                                                            }}
                                                            onClick={(e) => props.handleRowClick(row, iCol, e)}
                                                        >
                                                            {
                                                                !col.renderCell
                                                                    ? <> {row[col.field]} </>
                                                                    : col.renderCell(row)
                                                            }
                                                        </div>
                                                    </a>
                                                )
                                            })
                                        }
                                    </div>

                                    <div className="functions">
                                        {
                                            props.functionsRow &&
                                            <LcDropDown element={<LcIconLink icon="ppi ppi-dots-vertical" size="small" />} position="right">
                                                {
                                                    props.functionsRow.map((f, i) => {
                                                        if (!f.hidden || !f.hidden(row)) {
                                                            let disabled = (f.disabled && f.disabled(row)) || false;

                                                            return (
                                                                <div
                                                                    key={i}
                                                                    className={`item${disabled ? ' disabled' : ''}`}
                                                                    onClick={() => { !disabled && f.func(row) }}>
                                                                    {f.label}
                                                                </div>
                                                            )
                                                        }
                                                    })
                                                }
                                            </LcDropDown>
                                        }
                                    </div>
                                </div>
                            )
                        }
                    })
                }
            </LcAccordionAlt>
        </div>
    );
};

export default BodyGroupSingle;